<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">报名列表</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>支付方式：</label>
          <el-select v-model="payType" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in payTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="报名时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType" :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          以下支付价格总额：{{ paySum.toFixed(2) }}
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            border
            @cell-click="toggleSelection"
            v-loading="listLoading"
        >
          <!--          <el-table-column type="selection" width="55" />-->
          <el-table-column property="createTime" label="报名时间" v-if="checkColList.indexOf('报名时间') > -1"/>
          <el-table-column property="name" label="姓名" v-if="checkColList.indexOf('姓名') > -1" />
          <el-table-column property="uid" label="UID" v-if="checkColList.indexOf('UID') > -1" />
          <el-table-column property="phone" label="手机号" v-if="checkColList.indexOf('手机号') > -1" ></el-table-column>
          <el-table-column property="wechatId" label="微信号" v-if="checkColList.indexOf('微信号') > -1" ></el-table-column>
          <el-table-column property="subject" label="服务类型" v-if="checkColList.indexOf('服务类型') > -1"></el-table-column>
          <el-table-column property="payFee" label="支付价格" v-if="checkColList.indexOf('支付价格') > -1" />
          <el-table-column property="" label="支付方式" v-if="checkColList.indexOf('支付方式') > -1" >
            <template #default="scope">
              {{scope.row.payType==1?'支付宝支付':scope.row.payType==2?'微信支付':''}}
            </template>
          </el-table-column>
          <el-table-column property="applyRemark" label="报名备注" v-if="checkColList.indexOf('报名备注') > -1" />
          <el-table-column property="remark" label="备注" v-if="checkColList.indexOf('备注') > -1" class-name="cursor"/>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
// import BtnGroup from '../../components/BtnGroup'
import { getOneToOneApplyPageList } from '../../api/url'
import { getFormData } from '../../api/api'
import Dialog from '../../assets/js/dialog'
import UserLogDialog from '../../components/UserLog/UserLogDialog'
import ImgViewer from '../../assets/js/imageViewer'
import { common } from "@/assets/shared/select-constant";
import UserLog from "@/components/UserLog/UserLog";
import signUpRemarkDialog from "./components/signUpRemarkDialog";

export default {
  name: "SingleSignUp",
  components: { DatePickerRange, SearchComponents, UserLog },
  data() {
    return {

      payTypeArray: [
        {label: '不限', value: -1},
        {label: '支付宝', value: 1},
        {label: '微信', value: 2},
      ],
      payType: -1,

      paySum: 0,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //搜索
      searchTypeList: [
        {label : '姓名', value : 1},
        {label : '手机号', value : 2},
        {label : '微信号', value : 3},
        {label : 'uid', value : 4},
        {label : '服务类型', value : 5},
      ],
      searchType: 4,
      searchValue: '',

      //刷新组
      colList: ['报名时间', '姓名', 'UID', '手机号', '微信号', '服务类型', '支付价格', '支付方式', '报名备注', '备注'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

      dataSummary: [],

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.sex = -1;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['payType'] = this.payType;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getOneToOneApplyPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.pageDataList.forEach(item => {
            this.paySum += item.payFee
          })
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(row) {
      let imgList = []
      imgList.push(row.headImg.headImg)
      ImgViewer.open({
        imgList: imgList
      })
    },

    toggleSelection(row, column, cell, event) {

      //更新用户备注
      if(column.label == '备注') {
        let signUpForm = Object.assign({}, row);
        Dialog.open({
          title: '更新备注信息',
          component: signUpRemarkDialog,
          data: {
            signUpForm: signUpForm,
            width: '400px'
          },
          confirm: (res) => {
            row['remark'] = res.remark
          }
        })
      }

    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
